<template>
  <div class="search-results">
    <result-table-settings v-if="modeView === 'table'" />
    <div v-if="stateMessage" :class="stateMessage.type" class="message">
      {{ stateMessage.text }}
    </div>

    <loader-cubics v-if="isLoading" class="search-result__loader">
      <template v-slot:text
        >Идет поиск...</template
      >
    </loader-cubics>

    <template v-if="results.total">
      <search-result-list
        v-if="modeView === 'list'"
        :items="results.items"
        :current-item-id="currentDocumentId"
        @card-click="onButtonCardClick"
        @favorite-click="onButtonFavoriteClick"
        @watched-click="onButtonWatchedClick"
      />

      <search-result-table
        v-if="modeView === 'table'"
        :items="results.items"
        @favorite-click="onButtonFavoriteClick"
        @watched-click="onButtonWatchedClick"
      />

      <list-paginator
        v-if="results.total"
        :items-total="results.total"
        :items-per-page-options="[20, 50, 100]"
        items-per-page-label="Результатов на странице:"
        @update="handlePaginatorUpdate"
      />
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import ListPaginator from '@@/shared/list/ListPagination';
import SearchResultList from './SearchResultList';
import SearchResultTable from './SearchResultTable';
import LoaderCubics from '@@/shared/loaders/LoaderCubics';

import ResultTableSettings from '../ResultTableSettings';

export default {
  components: {
    LoaderCubics,
    ListPaginator,
    SearchResultList,
    SearchResultTable,
    ResultTableSettings
  },

  props: {
    modeView: {
      type: String
    },
    currentDocumentId: {
      default: null
    }
  },

  computed: {
    ...mapState(['search']),
    ...mapGetters({
      results: 'searchResults',
      isLoading: 'isLoading',
      query: 'searchQuery',
      classifiers: 'selectedClassifiers',
      checklists: 'selectedChecklists',
      currentSidebarStatus: 'sidebarStatus'
    }),

    stateMessage() {
      switch (true) {
        case this.isLoading:
          return false;
        case !this.query.text &&
          !this.classifiers.length &&
          !this.checklists.length:
          return {
            type: '_info',
            text:
              'Введите поисковый запрос, выберите классификаторы или перечни'
          };
        case !!this.search.loadingError:
          return {
            type: '_error',
            text: `Ошибка загрузки результатов поиска: «${
              this.search.loadingError.message
            }»`
          };
        case !this.results.total:
          return {
            type: '_attention',
            text: 'По вашему поисковому запросу не нашлось документов'
          };
        default:
          return false;
      }
    }
  },

  created() {
    if (!this.currentSidebarStatus)
      this.$store.dispatch('setSidebarStatus', 'filter');
  },

  methods: {
    onButtonCardClick(documentId) {
      this.$emit('card-click', documentId);
    },
    onButtonFavoriteClick(documentId, isFavorite) {
      this.$store.dispatch('toggleDocumentAsFavorite', {
        documentId: documentId,
        isFavorite: !isFavorite
      });
    },
    onButtonWatchedClick(documentId, isWatched) {
      this.$store.dispatch('toggleDocumentAsWatched', {
        documentId: documentId,
        isWatched: !isWatched
      });
    },
    handlePaginatorUpdate(obj) {
      if ('limit' in obj) {
        this.$store.dispatch('changeQueryParamAndUpdateResults', {
          param: 'limit',
          value: obj.limit
        });
      }
      if ('offset' in obj) {
        this.$store.dispatch('changeQueryParamAndUpdateResults', {
          param: 'offset',
          value: obj.offset //this.currentOffset
        });
      }
    }
  }
};
</script>
